import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Form, Segment, Icon, Button, Header } from "semantic-ui-react";
import { Link } from "react-router-dom";

const FlyerDownload = observer(({ tourId, editDisabled, flyerUrl, t }) => (
  <Segment>
    <Header as="h3" id="flyer-download">
      {t("clientPanelMisc:flyer")}
      {!editDisabled && (
        <Header.Subheader>
          <Link to={`/tours/${tourId}/flyer`}>{t("clientPanelMisc:editFlyer")}</Link>
        </Header.Subheader>
      )}
    </Header>
    <Form method="GET" action={flyerUrl} target="_blank">
      <Button type="submit" primary icon>
        <Icon name="download" />
        &nbsp;{t("clientPanelDownload:downloadFlyer")}
      </Button>
    </Form>
  </Segment>
));

FlyerDownload.propTypes = {
  tourId: PropTypes.number.isRequired,
  flyerUrl: PropTypes.string.isRequired,
  editDisabled: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

FlyerDownload.defaultProps = {
  editDisabled: false,
};

export default withTranslation()(FlyerDownload);
